import {
  PreScreeningQuestion,
  QuestionType,
} from "../../types/landingPage";
import { mappers } from "../../utils/attributeMapping/mappers";

/**
 * Shared pre-screening questions for vaccine studies
 * These questions are asked to ALL patients before zipcode entry
 * to optimize conversion by disqualifying ineligible patients early
 */
export const sharedVaccineScreeningQuestions: PreScreeningQuestion[] = [
  {
    id: "age_eligibility",
    type: QuestionType.RADIO,
    question: "What is your age?",
    required: true,
    allowBack: true,
    options: [
      {
        value: "17_or_under",
        label: "17 or under",
      },
      {
        value: "18_to_49",
        label: "18 to 49",
      },
      {
        value: "50_to_64",
        label: "50 to 64",
      },
      {
        value: "65_or_older",
        label: "65 or older",
      },
    ],
    disqualifyMessage:
      "Thank you for your interest. We don't have any studies available for your age range at this time.",
    attributeMapping: mappers.value({
      "17_or_under": [],
      "18_to_49": [],
      "50_to_64": [],
      "65_or_older": [],
    }),
  },
  {
    id: "past_vaccine_study_participation",
    type: QuestionType.RADIO,
    question: "Have you ever participated in a vaccine study before?",
    required: true,
    allowBack: true,
    options: [
      {
        value: "participated",
        label: "Yes, I have participated in a vaccine study before",
      },
      {
        value: "screened_not_enrolled",
        label: "I have screened for a vaccine study but didn't enroll",
      },
      {
        value: "tried_but_disqualified",
        label: "No, but I have tried to enroll but was disqualified",
      },
      {
        value: "never_participated",
        label: "No, I have never participated in a vaccine study",
      },
    ],
    attributeMapping: mappers.value({
      participated: [],
      screened_not_enrolled: [],
      tried_but_disqualified: [],
      never_participated: [],
    }),
  },
];
